var jqplayer = require('./views/jq-player');




//////////////////
// WEBPACK FOOTER
// ./~/draughts-reader/src/main.js
// module id = sJIX
// module chunks = 4